import { isProduction } from '..';
import type { AppConfig } from '../types';

export default {
  zone: 'asia-4',
  defaultLocale: 'id-ID',
  availableLocales: ['en-ID', 'id-ID'],
  timedBanners: {
    privatePolicyBanner: {
      privatePolicy: {
        displayDates: {
          startDate: '2023-11-15T00:00:00.000Z',
          endDate: '2023-12-20T23:59:59.000Z',
        },
        type: 'PrivacyPolicy',
      },
    },
    candidateOnboardingBanner: {
      displayDates: {
        startDate: '2023-11-15T00:00:00.000Z',
        endDate: '2023-12-20T23:59:59.000Z',
      },
      externalHelpURL: {
        en: 'https://help.jobstreet.co.id/s/article/Understanding-The-Changes-On-The-New-Jobstreet-by-SEEK-ID?language=en_US',
        id: 'https://help.jobstreet.co.id/s/article/Understanding-The-Changes-On-The-New-Jobstreet-by-SEEK-ID?language=in',
      },
    },
  },
  zoneFeatures: {
    QUICK_SEARCH_ENABLED: true,
    NORTHSTAR_SEO_TAGS: true,
    NUDGE_ENABLED: false,
    SHOW_HOMEPAGE_BANNER: true,
    HOMEPAGE_BANNER_TYPE: 'GENERIC_ASIA_BANNER',
    SEARCH_PAGE_SIZE: 30,
    SPLITVIEW_ENABLED: true,
    SHOW_FLOATING_SAVE_SEARCH: false,
    SHOULD_OPEN_APPLY_IN_NEW_TAB: true,
    AUTO_SELECT_SPLIT_VIEW_FIRST_JOB: false,
    SHOW_STICKY_APPLY_ON_DESKTOP: true,
    SERP_KEYWORD_TEXTFIELD: true,
    LMIS_ENABLED: true,
    SALARY_TRANSPARENCY_ENABLED: false,
    COMPANY_PROFILE_ON_JDV: true,
  },
  BRANCH_IO_KEY: isProduction
    ? 'key_live_keVW4JKlS0jBJLPfSRNUJnhhtElmK541'
    : 'key_test_igQ77GMmQ1itGVIiMGXzojmavAcg9pio',
} as AppConfig;
